import { Component, Input, OnDestroy, OnInit, inject } from "@angular/core";
import { PropertyService } from "@app/integrations/urm/services/property.service";
import { PropPropertyHeader } from "@app/integrations/urm/models/prop-property-header";
import { CautionService } from "@app/integrations/urm/services/caution.service";
import { PropTenantAttribute } from "@app/integrations/urm/models/prop-tenant-attribute";
import Clipboard from "clipboard";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatIcon } from "@angular/material/icon";
import { MatList, MatListItem } from "@angular/material/list";
import { MatLine } from "@angular/material/core";

@Component({
  selector: "urm-property-info",
  templateUrl: "./property-info.component.html",
  styleUrls: ["./property-info.component.css"],
  imports: [MatProgressBar, MatIcon, MatList, MatListItem, MatLine]
})
export class PropertyInfoComponent implements OnInit, OnDestroy {
  urmPropertyInfo = inject(PropertyService);
  cautionInfo = inject(CautionService);

  @Input()
  public externalPropertyReference: string = null;

  @Input()
  public listView: boolean = false;

  public loading = true;
  public error = false;
  public errorMessage = "";
  public propertyRecord: PropPropertyHeader;
  public tenantAttributes: PropTenantAttribute[];
  private clipboard: Clipboard;

  get fullAddress(): string {
    if (!this.propertyRecord) {
      return "";
    }

    const lines = [
      this.propertyRecord.Proh_PropertyName,
      this.propertyRecord.Proh_Address1,
      this.propertyRecord.Proh_Address2,
      this.propertyRecord.Proh_Address3,
      this.propertyRecord.Proh_Address4,
      this.propertyRecord.Proh_PostCode
    ];

    return lines.filter((line) => line).join(", ");
  }

  ngOnDestroy(): void {
    this.clipboard.destroy();
  }

  ngOnInit() {
    this.clipboard = new Clipboard(".copy-address-button", {
      text: () => this.fullAddress
    });
    this.urmPropertyInfo.loadPropertyById(this.externalPropertyReference).then(
      (value) => {
        this.loading = false;
        console.log("property result");
        console.log(value);
        this.propertyRecord = value;
        this.loading = false;
        this.cautionInfo
          .loadTenantAttributeByPropertyID(
            this.propertyRecord.Proh_PropertyIdentity
          )
          .then((value1) => {
            console.log("attribute", value1);
            this.tenantAttributes = value1;
          });
      },
      (reason) => {
        this.error = true;
        this.loading = false;
        console.log(reason);
        this.errorMessage = reason;
      }
    );
  }
}
